import styled from 'styled-components';
import LayoutPublic from '../components/LayoutPublic';
import Article from '../components/Article';
import SecondaryNav from '../components/SecondaryNav';
import { MOBILE_MENU_BREAKPOINT, mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import GuidesLandingPage from '../components/landingPages/guides';
import ApiLandingPage from '../components/landingPages/api';
import { useLocation } from 'react-router-dom';
import { proxiedSubdomainBasePath } from 'developer-docs-shared-components/utils/urls';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
// Does not have a ToC, so reclaiming that space.
const StyledArticle = styled(Article).withConfig({
  displayName: "LandingPage__StyledArticle",
  componentId: "sc-1kno0ac-0"
})(["padding-right:32px;&&{width:100%;}", "{padding-right:0;}h1,h2{margin-bottom:32px;}"], mediaQueries.belowWidth(MOBILE_MENU_BREAKPOINT));
function LandingPage({
  pageType,
  secondaryNavConfig
}) {
  const {
    pathname
  } = useLocation();
  const [, primaryDir, secondaryDir] = pathname.replace(proxiedSubdomainBasePath, '').split('/');
  const computedPath = `/${primaryDir}/${secondaryDir}`;
  const landingPageComponentMap = {
    '/reference/api': /*#__PURE__*/_jsx(ApiLandingPage, {}),
    '/guides/api': /*#__PURE__*/_jsx(GuidesLandingPage, {})
  };
  return /*#__PURE__*/_jsx(LayoutPublic, {
    maxContentWidth: 1200,
    sideNavComponent: /*#__PURE__*/_jsx(SecondaryNav, {
      navConfig: secondaryNavConfig
    }),
    footerWidth: "full",
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: `LANDING_PAGE_LOAD`,
      children: /*#__PURE__*/_jsx(StyledArticle, {
        "data-test-id": `${pageType}_LANDING_PAGE`,
        "data-layout": "2-column-wide-right",
        children: landingPageComponentMap[computedPath]
      })
    })
  });
}
export default LandingPage;